var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt',{attrs:{"img":"https://image.freepik.com/photos-gratuite/ouvrir-voler-vieux-livres_1232-2096.jpg","title":"Liste des notices thermostat"}}),_c('table-view'),_c('upload')],1)}
var staticRenderFns = []

export { render, staticRenderFns }